import { useParams } from "src/routes/hooks";
import Thread from "./Thread";

export default function ThreadByID() {
  const params = useParams();
  const { id } = params;
  return <Thread id={id} />;
}
